import React from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import { AppRouter } from "@MASTER";
import SupportTickets from "./support-tickets";
import SupportDocuments from "./support-documents";

const SolutionCenter = () => {
  let { path } = useRouteMatch();

  return (
    <Switch>
      <AppRouter path={`${path}/destek-talepleri`} title="Destek Talepleri">
        <SupportTickets />
      </AppRouter>
      <AppRouter path={`${path}/destek-dokumanlari`} title="Destek Dokümanları">
        <SupportDocuments />
      </AppRouter>
      <Route path={path}>
        <Redirect to={`${path}/destek-talepleri`} />
      </Route>
    </Switch>
  );
};

export default SolutionCenter;
